import { render, staticRenderFns } from "./cabinet-notice-card-row-single.vue?vue&type=template&id=48b1559e&"
import script from "./cabinet-notice-card-row-single.vue?vue&type=script&lang=js&"
export * from "./cabinet-notice-card-row-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b1559e')) {
      api.createRecord('48b1559e', component.options)
    } else {
      api.reload('48b1559e', component.options)
    }
    module.hot.accept("./cabinet-notice-card-row-single.vue?vue&type=template&id=48b1559e&", function () {
      api.rerender('48b1559e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/partials/cabinet-notice-card-row-single.vue"
export default component.exports